import React from "react";
import { Link } from "react-router-dom";

const CitizenOBPSHomeCard = ({ header, links, state, Icon, Info, isInfo = false, styles }) => {
  return (
    <div className="CitizenOBPSHomeCard" style={styles ? styles : {}}>
      <div className="complaint-links-container-obps">
      <div className="header">
        <h2>{header}</h2>
        <span style={{ borderRadius: '99999px', padding: '7px', color: 'white', marginLeft: 'auto', color: 'white'}}><Icon /></span> 
      </div>

      <div className="links">
        {links.map((e, i) => (
          <Link key={i} to={{ pathname: e.link, state: e.state }}>
            {e.i18nKey}
          </Link>
        ))}
      </div>
      <div>
        {isInfo ? <Info /> : null} 
      </div>
    </div>
    </div>
  );
};

export default CitizenOBPSHomeCard;
